import _ from "lodash";
import ZArray from "./ZArray";
import Accessor from "./Accessor";

class LogicX {

  static isNullOrUndefined(target){
    return target === null || target === undefined;
  }

  /**
   * 
   * @param {*} target 
   * @param {*[]} options 
   * @returns 
   */
  static isOneOf(target, options){
    options = ZArray.Ensure(options);
    for(let i=0; i<options.length; i++){
      if(target === options[i]) return true;
    }
    return false;
  }

   /**
   * 
   * @param {*} target 
   * @param {*[]} options 
   * @returns 
   */
   static includesOneOf(target, options){
    options = ZArray.Ensure(options);
    for(let i=0; i<options.length; i++){
      if(target?.includes?.(options[i])) return true;
    }
    return false;
  }

  /**
   * 
   * @param {*} formValue 
   * @param {String | String[]} fields 
   * @param {(value) => Boolean} validateFunc 
   */
  static CheckAllValid(formValue, fields, validateFunc){
    return _.every(fields, o => {
      let value = Accessor.Get(formValue, o);
      return validateFunc(value);
    });
  }

  /**
   * 
   * @param {*} formValue 
   * @param {String | String[]} fields 
   * @param {(value) => Boolean} validateFunc 
   */
  static CheckEitherOneValid(formValue, fields, validateFunc){
    return _.some(fields, o => {
      let value = Accessor.Get(formValue, o);
      return validateFunc(value);
    });
  }

}

export default LogicX;